export default "__VITE_ASSET__49b4bd68__"